import { setMemoryReference, useMemoryReference } from "lib/@hooks/use-memory-reference"

export const RETIRED_SELECTION_TYPE = "retired-selection"

export function useRetiredSelection() {
    const [reference, save] = useMemoryReference({ retiredSelection: {} }, RETIRED_SELECTION_TYPE)
    reference.retiredSelection ||= {}
    return [reference.retiredSelection, toggle, isRetiredSelected]

    function isRetiredSelected(id) {
        return !!reference.retiredSelection[id]
    }

    function toggle(id, value = !isRetiredSelected(id)) {
        save((r) => ({ ...r, retiredSelection: { ...r.retiredSelection, [id]: value } }))
    }
}

export function setRetiredSelection(selector) {
    setMemoryReference((reference) => {
        reference.retiredSelection ??= {}
        reference.retiredSelection = selector(reference.retiredSelection)
        return reference
    }, RETIRED_SELECTION_TYPE)
}

export function getSelectedRetiredIds(selection) {
    return Object.keys(selection).filter((id) => selection[id])
}
